import { Card } from "../../types";
import { SortRule, SortField } from "./sort-controls";

export function sortCards(cards: Card[], sortRules: SortRule[]): Card[] {
  if (sortRules.length === 0) {
    return cards;
  }

  const sortedCards = [...cards];

  sortedCards.sort((firstCard, secondCard) => {
    for (const sortRule of sortRules) {
      const comparisonResult = compareByField(
        firstCard,
        secondCard,
        sortRule.field,
        sortRule.direction,
      );
      if (comparisonResult !== 0) {
        return comparisonResult;
      }
    }
    return 0;
  });

  return sortedCards;
}

function compareByField(
  firstCard: Card,
  secondCard: Card,
  sortField: SortField,
  sortDirection: "asc" | "desc",
): number {
  let firstCardValue: any;
  let secondCardValue: any;

  switch (sortField) {
    case "score":
      firstCardValue = Number(firstCard.match_percentage) || 0;
      secondCardValue = Number(secondCard.match_percentage) || 0;
      break;
    case "capacity":
      firstCardValue = firstCard.capacity || 0;
      secondCardValue = secondCard.capacity || 0;
      break;
    case "size":
      firstCardValue = firstCard.size || 0;
      secondCardValue = secondCard.size || 0;
      break;
    case "credits":
      firstCardValue = firstCard.credits || 0;
      secondCardValue = secondCard.credits || 0;
      break;
    case "monthly_price":
      firstCardValue = firstCard.monthly_price || 0;
      secondCardValue = secondCard.monthly_price || 0;
      break;
    case "title":
      firstCardValue = (firstCard.title || "").toLowerCase();
      secondCardValue = (secondCard.title || "").toLowerCase();
      break;
    case "space_name":
      firstCardValue = (firstCard.space?.name || "").toLowerCase();
      secondCardValue = (secondCard.space?.name || "").toLowerCase();
      break;
    case "address":
      firstCardValue = (firstCard.address || "").toLowerCase();
      secondCardValue = (secondCard.address || "").toLowerCase();
      break;
    case "updated_at":
      firstCardValue = firstCard.updated_at
        ? new Date(firstCard.updated_at).getTime()
        : 0;
      secondCardValue = secondCard.updated_at
        ? new Date(secondCard.updated_at).getTime()
        : 0;
      break;
    case "status":
      firstCardValue = firstCard.status || 0;
      secondCardValue = secondCard.status || 0;
      break;
    default:
      return 0;
  }

  let comparisonResult = 0;
  if (
    typeof firstCardValue === "string" &&
    typeof secondCardValue === "string"
  ) {
    comparisonResult = firstCardValue.localeCompare(secondCardValue, "pt-BR", {
      sensitivity: "base",
      numeric: true,
    });
  } else {
    comparisonResult =
      firstCardValue < secondCardValue
        ? -1
        : firstCardValue > secondCardValue
          ? 1
          : 0;
  }

  return sortDirection === "asc" ? comparisonResult : -comparisonResult;
}
